import {Injectable} from '@angular/core';
import {LOCATIONWISE_EP} from '../../config';
import {Observable} from 'rxjs/Observable';
import {ApiService} from './api.service';

@Injectable()
export class LocationwisEpService {
  constructor(private apiService: ApiService) {
  }

  getEp(): Observable<any> {
    return Observable.create(obs => {
      this.apiService.get(LOCATIONWISE_EP).subscribe(result => {
        let obj
        if (result['status'] === 'success') {
          if (!result['data']['timezone_value']) {
            let data = result['data'];
            obj = {smtp_ep: data['smtp_ep'], api_ep: data['api_ep'], link_ep: data['link_ep']};
          }
        }
        obs.next(obj);
        obs.complete();
      });
    });
  }
}
